import { Accordion } from "@jsq/ds/core";
import {
  ComplianceCaseTypeEnum as CaseType,
  ComplianceCaseStatus,
} from "~/graphql/supergraphEnums";
import { type GetComplianceCaseQuery } from "~/graphql/supergraphTypes";
import ImpactedGPGrid from "../ImpactedGPGrid";
import { useImpactedGPContext } from "../ImpactedGPGrid/impactedGPcontext";
import * as styles from "../styles_vanilla.css";

type ExpandableTextPanelProps = {
  complianceCase: GetComplianceCaseQuery["complianceCase"];
};

export const ExpandableTextPanel = (props: ExpandableTextPanelProps) => {
  const { count } = useImpactedGPContext();
  const { complianceCase } = props;
  const caseType = complianceCase?.caseType;
  const caseStatus = complianceCase?.status;

  return (
    <Accordion
      data-testid="expandable-text-panel"
      className={styles.detailViewIssue}
      title={
        caseType === CaseType.Escalation
          ? `Escalation cases were created for ${count} ${Number(count) > 1 ? "GPs" : "GP"}`
          : `Additional escalation cases ${caseStatus === ComplianceCaseStatus.Closed ? "were" : "will be"} created for ${count} ${Number(count) > 1 ? "GPs" : "GP"}`
      }
    >
      {caseType && (
        <ImpactedGPGrid
          caseType={caseType}
          caseId={complianceCase?.id}
          profileId={complianceCase.investingProfile?.id ?? 0}
          caseStatus={complianceCase.status}
        />
      )}
    </Accordion>
  );
};
